import { SvgIcon, type SvgIconProps } from './svgIcon'

export const ArrowBackIcon = ({
  width = 24,
  height = 24,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox={`0 0 20 20`} {...props}>
    <path
      d="M6.66667 14.1693L2.5 10.0026M2.5 10.0026L6.66667 5.83594M2.5 10.0026L17.5 10.0026"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </SvgIcon>
)
